export const nonsenseWordRepetitionStates = {
    LOADING: 'LOADING',
    PLAY_EXAMPLE_INTRO: 'PLAY_EXAMPLE_INTRO',
    PLAY_VIDEO: 'PLAY_VIDEO',
    PLAY_EXAMPLE_PROMPT: 'PLAY_EXAMPLE_PROMPT',
    WAITING_FOR_USER_INPUT_AFTER_PROMPT: 'WAITING_FOR_USER_INPUT_AFTER_PROMPT',
    PLAY_EXAMPLE_REPROMPT: 'PLAY_EXAMPLE_REPROMPT',
    PLAY_REPROMPT: 'PLAY_REPROMPT',
    WAITING_FOR_USER_INPUT_AFTER_REPROMPT: 'WAITING_FOR_USER_INPUT_AFTER_REPROMPT',
    REPLAY_VIDEO: 'REPLAY_VIDEO',
    WAITING_FOR_USER_INPUT_AFTER_REPLAY: 'WAITING_FOR_USER_INPUT_AFTER_REPLAY',
    REGISTER_EXAMPLE_ENDING_SPEECH: 'REGISTER_EXAMPLE_ENDING_SPEECH',
    WAITING_FOR_ENDING_SPEECH: 'WAITING_FOR_ENDING_SPEECH',
    END: 'END',
  }